// document.addEventListener("DOMContentLoaded", () => {
//   document.getElementById("header").classList.add("stick");
// });



const header = document.getElementById("header");

window.addEventListener("scroll", () => {
  if (window.scrollY >= 50) {
    header.classList.add("stick");
  } else {
    header.classList.remove("stick");
  }
});



const header2 = document.querySelector("#header2");

window.addEventListener("scroll", () => {
  if (window.scrollY >= 100) {
    header2.classList.add("stick2");
  } else {
    header2.classList.remove("stick2");
  }
});




